import { Navbar } from '@/ui/components/navigation/Navbar';
import { h, defineComponent } from 'vue';

export default defineComponent({
  name: 'TestLayout',
  setup() {
    return function render() {
      return h('div', [
        h(Navbar),
        h('router-view', { class: 'p-8 pt-20' }),
      ]);
    };
  },
});
